export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./fast-games.vue?vue&type=template&id=17ac3f44"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/fast-games.vue?vue&type=template&id=17ac3f44
// module id = VUt/
// module chunks = 0